<template>
  <label class="custom-label flex cursor-pointer">
    <input type="checkbox" class="hidden" :value="modelValue" :checked="checked" @change="change">
    <svg v-if="checked" class="size-6 shrink-0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.89543 24 2 24H22C23.1046 24 24 23.1046 24 22V2C24 0.895431 23.1046 0 22 0H2ZM10.6811 18.5L20.8044 8.28992L19.5 7L10.5679 16.0321L5.18093 11.0986L4 12.5L10.6811 18.5Z" fill="#4D4D4D" />
    </svg>
    <svg v-else class="size-6 shrink-0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.75"
        y="0.75"
        width="22.5"
        height="22.5"
        rx="1.25"
        fill="white"
        stroke="#4D4D4D"
        stroke-width="1.5"
      />
    </svg>

    <span class="ml-3 inline-block">
      <slot />
    </span>
  </label>
</template>

<script>
export default {
  props: {
    modelValue: { type: [String, Number, Object, Array], required: true },
    checked: Boolean,
  },

  emits: ['change'],

  methods: {
    change (e) {
      this.$emit('change', e)
    },
  },
}
</script>
